<template>
    <nav :class="[isMobile ? 'navbar-top' : 'navbar-container position-fixed vh-100 border-end']"
        :style="{ width: isMobile ? '100%' : '300px' }">
        <!-- Logo y botón de colapso -->
        <div class="row align-items-center p-3 mt-4">
            <div class="col-9">
                <router-link class="navbar-brand w-100 p-2" to="/">
                    <img :src="logo" class="logo img-fluid" alt="main_logo" />
                </router-link>
            </div>
            <div class="col-3 text-end">
                <!-- Botón para colapsar (visible solo en móviles) -->
                <button class="btn btn-outline-dark d-md-none mb-0" @click="toggleSidebar">
                    <i :class="isCollapsed ? 'bi bi-list' : 'bi bi-x'"></i>
                </button>
            </div>
        </div>

        <transition name="slide-fade">
            <ul v-show="!isCollapsed || !isMobile" class="nav flex-column p-3">

                <!-- Manual de Usuario desplegable -->
                <li class="nav-item">
                    <div class="accordion" id="userManualAccordion">
                        <div class="accordion-item">
                            <h6 class="accordion-header" id="headingOne">
                                <button class="accordion-button btn-sm py-1 px-2 collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false"
                                    aria-controls="collapseOne">
                                    <i class="bi bi-journal-text me-2"></i> Manual de Usuario &nbsp; &nbsp; &nbsp; &nbsp;<i class="bi bi-caret-down-fill dropdown-arrow ms-auto"></i>
                                </button>
                            </h6>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#userManualAccordion">
                                <div class="accordion-body p-0">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item">
                                            <router-link to="/user-manual-signup" class="nav-link text-dark">
                                                <i class="bi bi-person-vcard"></i> Registrar una Cuenta
                                            </router-link>
                                        </li>
                                        <li class="list-group-item">
                                            <router-link to="/user-manual-signin" class="nav-link text-dark">
                                                <i class="bi bi-door-open-fill"></i> Inicio de Sesión
                                            </router-link>
                                        </li>
                                        <li class="list-group-item">
                                            <router-link to="/user-manual-events" class="nav-link text-dark">
                                                <i class="bi bi-calendar4-week"></i> Registro de Eventos
                                            </router-link>
                                        </li>
                                        <li class="list-group-item">
                                            <router-link to="/user-manual-hours" class="nav-link text-dark">
                                                <i class="bi bi-alarm-fill"></i> Registro de Horas
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <!-- Documentación fuera del desplegable -->
                <li class="nav-item mt-2">
                    <div class="accordion" id="docsAccordion">
                        <div class="accordion-item">
                            <h6 class="accordion-header" id="headingTwo">
                                <button class="accordion-button btn-sm py-1 px-2 collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                                    aria-controls="collapseTwo">
                                    <i class="bi bi-book me-2"></i> Documentación &nbsp; &nbsp; &nbsp; &nbsp;<i class="bi bi-caret-down-fill dropdown-arrow ms-auto"></i>
                                </button>
                            </h6>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingOne"
                                data-bs-parent="#docsAccordion">
                                <div class="accordion-body p-0">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item">
                                            <router-link to="/documentation" class="nav-link text-dark">
                                                <i class="bi  bi-file-text-fill"></i> Próximamente
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </transition>

    </nav>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import logo from "@/assets/img/nexon-gray.png";

const isCollapsed = ref(true);
const isMobile = ref(window.innerWidth < 1200);

const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value;
};

// Detectar tamaño de pantalla
const handleResize = () => {
    isMobile.value = window.innerWidth < 1200;
    if (!isMobile.value) {
        isCollapsed.value = false; // Mostrar siempre en escritorio
    }
};

onMounted(() => {
    window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
/* Contenedor principal del navbar */
.navbar-container {
    width: 100%;
    max-width: 300px;
    transition: transform 0.3s ease-in-out;
    z-index: 1050;
    top: 0;
    /* Poner en la parte superior */
    left: 0;
    /* Alinear a la izquierda */
}

/* Estilos para navbar en móvil */
.navbar-top {
    position: relative;
    width: 100%;
    height: auto;
    border-bottom: 1px solid #dee2e6;
}

/* Menú desplegable */
.nav {
    list-style: none;
    padding: 0;
    margin: 0;
}

/* Tamaño adecuado del logo */
.logo {
    max-height: 50px;
    width: auto;
    object-fit: contain;
}

/* Transición suave */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* Rotación de flecha con transición */
.dropdown-arrow {
    transition: transform 0.3s ease;
}

.accordion-collapse.show + .accordion-body .dropdown-arrow,
.accordion-button:not(.collapsed) .dropdown-arrow {
    transform: rotate(180deg);
}

</style>
